module.exports = __webpack_public_path__ + "img/chevron-up.0ba0759b.svg";